import { useClerk } from '@clerk/clerk-react';

/**
 * useSignOutHandler
 * Resolves Clerk signOut internally — no props needed.
 * Caller gets a single handle() function.
 */
export default function useSignOutHandler() {
    const { signOut } = useClerk();

    /**
     * Executes sign out flow.
     * TODO: publish(events.onUserSignOut) — onUserSignOut not yet in SystemEvents
     */
    const handle = async () => {
        await signOut({ redirectUrl: '/' });
    };

    return { handle };
}
